module.exports = __webpack_public_path__ + "img/award-01.0d537084.svg";